<template>
   <section class="breadcrumbs-custom">
    <!-- <div class="parallax-container">
        <div class="material-parallax parallax"><img src="/assets/images/breadcrumbs-bg.jpg" alt="breadcrumbs"></div>
        <div class="breadcrumbs-custom-body parallax-content context-dark">
        <div class="container">
            <h2 class="breadcrumbs-custom-title">Forgot Password</h2>
        </div>
        </div>
    </div> -->
    <div class="breadcrumbs-custom-footer">
        <div class="container">
        <ul class="breadcrumbs-custom-path">
            <li><router-link to="/">Home</router-link></li>            
            <li class="active">Forgot Password</li>
        </ul>
        </div>
    </div>
    </section>

   <section class="section section-xxl bg-default">
      <div class="container">
         <div class="row row-40 justify-content-center">         
            <div class="col-sm-10 col-md-6">
               <div class="inset-xl-right-50">
                  <h3>Forgot Password</h3>
                  <div class="group group-middle group-button-1">
                     <h6>Please enter your email address and we'll send you a link to reset your password.</h6>
                  </div>
                  <!-- RD Mailform-->
                  <form @submit.prevent="submitForm" class="rd-form rd-mailform" novalidate="novalidate">
                  <div class="form-wrap" :class="{ 'has-error': v$.forgotPasswordData.email.$error || store.isServeError && serverError.hasOwnProperty('email') }">
                     <input v-model="forgotPasswordData.email" class="form-input form-control-has-validation" id="forgot-email" type="text" data-constraints="@Required">
                     <label class="form-label rd-input-label" for="forgot-email">Email</label>
                     <span v-if="v$.forgotPasswordData.email.$error" class="form-validation">
                        {{ emailErrorMsg }}
                     </span>
                     <span v-if="store.isServeError && serverError.hasOwnProperty('email')" class="form-validation">{{ serverError.email[0] }}</span>
                  </div>                                  
                  <div class="group-sm group-middle group-button-1">
                     <button class="button button-lg button-primary button-zakaria" type="submit" :disabled="isSubmitting">
                        <span v-if="isSubmitting">Submitting...</span>
                        <span v-else>Submit</span>
                     </button>
                     <router-link class="button button-lg button-secondary button-zakaria" to="/login">Back to Login</router-link>
                  </div>
                  <p v-if="errorMessage" class="text-danger mt-3">{{ errorMessage }}</p>
                  <p v-if="successMessage" class="text-success mt-3">{{ successMessage }}</p>
                  </form>
               </div>
            </div>
         </div>
      </div>
   </section>
</template>
<script setup>
import { onMounted, computed } from 'vue'
import { useHead } from '@unhead/vue'
import { useCartStore } from '@/stores/cart'
import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
import { useAuthStore } from '@/stores/authStore'
import { storeToRefs } from 'pinia'

const cartStore = useCartStore()

const store = useAuthStore()
const { forgotPasswordData, isSubmitting, successMessage, errorMessage, serverError } = storeToRefs(store)

useHead({
  title: 'Forgot Password - CakeGurus',
  meta: [
    {
      name: 'description',
      content: 'Forgot your password? Enter your email to reset it.',
    },
  ],
})

const rules = {
  forgotPasswordData: {
    email: { required, email },
  },
}

const v$ = useVuelidate(rules, { forgotPasswordData })

const emailErrorMsg = computed(() => {
  if (!v$.value.forgotPasswordData.email.$dirty) return ''
  if (!v$.value.forgotPasswordData.email.required) return 'The field is required'
  if (!v$.value.forgotPasswordData.email.email) return 'Invalid email format'
  return ''
})

async function submitForm() {
  v$.value.$touch()
  if (v$.value.$invalid) {
    errorMessage.value = 'Please fix the form errors before submitting.'
    return
  }
  store.forgotPassword()  
}

onMounted(() => {
    cartStore.loadCart()
    
    const scriptId = 'script-js-script'

    // Check if the script already exists
    const existingScript = document.getElementById(scriptId)

    if (existingScript) {
        // Replace it: remove and re-add
        existingScript.remove()
    }

    // Create and append a fresh script
    const newScript = document.createElement('script')
    newScript.src = '/assets/js/script.js'
    newScript.id = scriptId
    document.body.appendChild(newScript)
})
</script>
